import type { SearchFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/searchFilterInstance";

import AppAdSellersFilter from "../../components/filters/AppAdSellersFilter/AppAdSellersFilter";
import AppAdSellersFilterResult from "../../components/filters/AppAdSellersFilter/AppAdSellersFilterResult";
import type { IAppsAdsSellersFilterDescriptionDto } from "../../types/descriptionDto";
import { appsFilterCategoryMap } from "../../types/filterCategory";

import FindAppsAdsSellersFilter from "./AdsSellersFilter";

const createAdsSellersFilter = (description: IAppsAdsSellersFilterDescriptionDto): SearchFilterInstance => ({
    key: "adsSellers",
    trackingName: "App Ads Sellers",
    apiCategory: "appsFilters",
    category: appsFilterCategoryMap.apps,
    title: { key: "si.find_apps.filters.ads_sellers.title" },
    tooltipText: { key: "si.find_apps.filters.ads_sellers.tooltip" },
    filter: new FindAppsAdsSellersFilter({
        options: description,
    }),
    filterView: AppAdSellersFilter,
    filterResultView: AppAdSellersFilterResult,
});

export default createAdsSellersFilter;
